






































































































































import {Component, Model, Prop, Vue, Watch} from 'vue-property-decorator';
import NodesTreeAddDialog from '@/components/nodesTree/NodesTreeAddDialog.vue';
import NodesTreeRemoveDialog from '@/components/nodesTree/NodesTreeRemoveDialog.vue';
import NodesTreeEditDialog from '@/components/nodesTree/NodesTreeEditDialog.vue';
import draggable from 'vuedraggable';
import {findNodeById} from '@/utils/nodeUtils';
import SimpleDialog from '@c/SimpleDialog.vue';
import {NodeData} from '@/system/nodes/interfaces';
import nodeModule from '@/store/modules/entities/nodeModule';
import serviceModule from '@/store/modules/entities/serviceModule';
import {ServiceData} from '@/services/interfaces';
import userSettingsModule from '@/store/modules/userSettingsModule';
import {NodeType} from '@e/NodeTypes';

@Component({
  computed: {
    NodeType() {
      return NodeType;
    },
  },
  components: {
    NodesTreeAddDialog,
    NodesTreeRemoveDialog,
    NodesTreeEditDialog,
    draggable,
    SimpleDialog,
  },
})
export default class NodesTree extends Vue {
  // Режим редактирования
  @Prop({required: false, default: true})
  edit!: boolean;

  // Список узлов дерева
  @Prop({required: true, type: Array})
  items!: NodeData[];

  // Строка поиска
  @Prop({required: false, type: String, default: ''})
  search!: string;

  @Watch('items')
  onItemsChanged(newValue: any, prevValue: any) {
    const id = this.$route.params.id;
    //обновляем selectedNode по новым данным, если он был выбран
    if (this.selectedNode) {
      this.selectedNode = findNodeById(this.selectedNode.id, this.items);

      if (this.selectedNode && !this.openItems.includes(this.selectedNode))
        this.openItems.push(this.selectedNode);
    }
    if (!prevValue.length) {
      if (id) this.openAllNodes();
      else {
        const openNodes = localStorage.getItem('openNodes');
        if (openNodes) {
          this.openNodesStorage = JSON.parse(openNodes);
          if (this.openNodesStorage.nodesTree) this.openItems = this.openNodesStorage.nodesTree;
        }
      }
    }
  }

  @Watch('openItems')
  onOpenItemsChange(newValue: any) {
    if (this.firstOpen) this.firstOpen = false;
    else {
      const settings = {
        dashboard: this.openNodesStorage ? this.openNodesStorage.dashboard : null,
        nodesTree: newValue,
      };
      userSettingsModule.setOpenNodes(settings);
    }
  }

  @Watch('selectedNode')
  changeSelectedNode() {
    if (this.selectedNode) this.activeItems = [this.selectedNode];
    this.$emit('changeRoute', this.selectedNode);
  }

  // Ключ для перерисовки элементов дерева
  // Необходимо для обновления css классов элементов дерева при установке locked
  key = 0;

  // Модель выбранного узла
  @Model('change') _selectedNode!: NodeData | null;

  get selectedNode() {
    return this._selectedNode;
  }

  set selectedNode(newValue: NodeData | null) {
    this.$emit('change', newValue);
  }

  get selectedNodeModel() {
    if (this.selectedNode) return {...this.selectedNode};
    return null;
  }
  get selectedParentNode() {
    if (this.selectedNode && this.selectedNode.parent) {
      return this.selectedNode.parent;
    }
    return null;
  }

  // Список активных элементов
  activeItems: NodeData[] = [];

  // Список открытых элементов
  openItems: NodeData[] = [];

  // Список открытых до начала поиска элементов
  lastOpenItems: NodeData[] = [];

  services: ServiceData[] = [];

  openNodesStorage: any = null;

  firstOpen = true;

  // При поиске запоминаем открытые узлы и раскрываем все найденные узлы, при завершении поиска возвращаем к ранее открытым
  @Watch('search')
  onSearch(newVal: string, oldVal: string) {
    if (newVal && oldVal === '') {
      this.lastOpenItems = [...this.openItems];
      this.openAllNodes();
    } else if (newVal === '') {
      this.openItems = [...this.lastOpenItems];
    }
  }

  async created() {
    if (this.selectedNode) {
      this.openAllNodes();
      this.activeItems = [this.selectedNode];
    }
    await serviceModule.fetchAll();
    // сервер возвращает facility_structure в списке сервисов, для настройки он нам не нужен, тк есть "workload"
    this.services = [...serviceModule.all].filter(service => service.name !== 'facility_structure');
  }

  // Показатель режима перемещения узлов
  drag = false;

  // Идентификатор перемещаемого узла
  dragItemId: number | null = null;

  // Идентификатор узла, к которому происходит перемещение
  dropItemId: number | null = null;

  // Модель для диалога перемещения узла
  dragDialog = false;

  dragForbidden = false;
  @Watch('dragDialog')
  onDragDialog(value: boolean) {
    if (!value) {
      this.dragItemId = null;
      this.dropItemId = null;
    }
  }

  // Выбранная опция в drag диалоге
  dragDialogOption = 1;

  // Перемещаемый элемент
  get dragItem() {
    if (this.dragItemId) return findNodeById(this.dragItemId, this.items);
    return null;
  }

  // Элемент к которому происходит перемещение
  get dropItem() {
    if (this.dropItemId) return findNodeById(this.dropItemId, this.items);
    return null;
  }

  // Обработчик перемещения узла
  onMove(evt: any) {
    this.dropItemId = Number.parseInt(evt.to.id);
    return false;
  }

  // Начало перемещения узла
  dragStart(evt: any) {
    this.dragItemId = Number.parseInt(evt.from.id);
    if (this.dragItem) this.lockNodes(this.dragItem, true);
  }

  // Завершение перемещения узла
  dragEnd() {
    const showDialog = !(this.dropItem as any).locked;
    if (this.dragItem && this.dropItem && this.dragItem.type < this.dropItem.type) {
      this.dragForbidden = true;
      return;
    }

    if (this.dragItem) this.lockNodes(this.dragItem, false);
    if (showDialog) {
      this.dragDialog = true;
    } else {
      this.dragItemId = null;
      this.dropItemId = null;
      this.key++;
    }
  }

  // Действия при обновлении активного элемента
  onUpdateActive(e: any) {
    if (e && e.length > 0) this.selectedNode = e[0];
    else this.selectedNode = null;
    this.$emit('selectNode', this.selectedNode);
  }

  // Действия при добавлении узла
  async onAddNode(node: NodeData) {
    const addedNode = await nodeModule.save(node);
    this.$emit('reload', addedNode);
  }

  // Действия при удалении узла
  async onRemoveNode(node: NodeData) {
    const removedNode = await nodeModule.delete(node.id);
    this.$emit('reload', removedNode);
  }

  // Действия при редактировании узла
  async onEditNode(node: NodeData) {
    const editedNode = await nodeModule.save(node);
    this.$emit('reload', editedNode);
  }

  // Действия при перемещении узла
  async onDrag() {
    if (!this.dragItemId || !this.dropItemId) return;
    const dragModel = await nodeModule.move({
      id: this.dragItemId,
      to: this.dropItemId,
      inside: this.dragDialogOption > 1,
    });
    this.$emit('reload', dragModel);
    this.dragDialog = false;
  }

  // Заблокировать зависимые узлы
  lockNodes(node: NodeData, locked: boolean) {
    const stack = [node];
    while (stack.length) {
      const x = stack.pop();
      (x as any).locked = locked;
      if (x && x.children) x.children.forEach(c => stack.push(c));
    }
  }

  // Открыть все узлы
  openAllNodes() {
    const open: NodeData[] = [];
    this.items.forEach(node => {
      const stack = [node];
      while (stack.length) {
        const x = stack.pop();
        if (x && x.children) {
          open.push(x);
          x.children.forEach(c => stack.push(c));
        }
      }
    });
    this.openItems = [...open];
  }
}
